//@Core
import React from "react";

//@Third Party
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { ButtonBase } from "@mui/material";

//@Dev
// # Locale
import * as Images from "../../../../images";
import Dots from "../../../../Components/Loader/Dots";
import UseGetData from "../../../../HookAxios/getdata";
import { GET_REQUEST } from "../../../../HooksApi/useApi";
import * as Style from "../DepartmentCourse/StyledDepartmentCourse";

export function WorkingPapers() {
  //* @Initiate
  const nav = useNavigate();
  const { idCourse } = useParams();

  //* @Component State
  // # Locale State
  const [expanded, setExpanded] = React.useState("");
  // # Global State
  const token = useSelector((state) => state.Auth.userInfo.token);

  //* @Async
  const { isLoading: isWorkingPapersLoading, data: WorkingPapersData } =
    GET_REQUEST({
      queryKey: `work_papers${idCourse}`,
      request: () =>
        UseGetData(
          `work_papers/${idCourse}`,
          {},
          {
            Authorization: `Bearer ${token}`,
          }
        ),
      enabled: true,
    });

  //* @Handlers
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const handleFileClick = (fileId) => {
    console.log("the file id is ", fileId);
    nav(`/course-working-paper/${idCourse}/file/${fileId}`);
  };

  return (
    <Style.Section>
      {!isWorkingPapersLoading ? (
        WorkingPapersData.data.data.map((item) => (
          <Style.Accordion
            key={item.id}
            expanded={expanded === item.id}
            onChange={handleChange(item.id)}
          >
            <Style.AccordionSummary>
              <Style.AccordionContent>
                <Style.AccordionContentText>
                  <Style.AccordionText>{item.title}</Style.AccordionText>
                </Style.AccordionContentText>
              </Style.AccordionContent>
            </Style.AccordionSummary>

            <Style.AccordionDetails>
              <>
                {item.work_paper_ids_question.map((element) => (
                  <Style.AccordionContentVed
                    key={element.id}
                    component={ButtonBase}
                    onClick={() => handleFileClick(element.id)}
                    style={{ width: "100%" }}
                  >
                    <Style.AccordionContentVedItems>
                      <Style.Icon src={Images.pdf} alt="pdf" />
                      <Style.AccordionText sx={{ fontSize: "14px" }}>
                        {element.title}
                      </Style.AccordionText>
                    </Style.AccordionContentVedItems>
                  </Style.AccordionContentVed>
                ))}
              </>
            </Style.AccordionDetails>
          </Style.Accordion>
        ))
      ) : (
        <Dots />
      )}
    </Style.Section>
  );
}
